import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Fetches a file (attachment) through the authorized backend endpoint,
 * exposes it as a blob URL suitable for <img src> / <a href> / <iframe src>.
 * Revokes the URL on unmount. No token ever appears in the URL.
 */
export default function useBlobFile(fileId, enabled = true) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fileId || !enabled) {
      setUrl(null); setError(null); setLoading(false);
      return () => {};
    }
    let cancelled = false;
    let currentUrl = null;
    setLoading(true); setError(null);
    api.get(`/files/${fileId}`, { responseType: "blob" })
      .then((r) => {
        if (cancelled) return;
        currentUrl = URL.createObjectURL(r.data);
        setUrl(currentUrl);
      })
      .catch((e) => { if (!cancelled) setError(e); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [fileId, enabled]);

  return { url, loading, error };
}

/** Trigger a download (fetch blob then create ephemeral anchor). */
export async function downloadFileById(fileId, filename) {
  const r = await api.get(`/files/${fileId}`, { responseType: "blob" });
  const blob = r.data;
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename || "fajl";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 5000);
}
